module.exports = __webpack_public_path__ + "img/lara.d6866e63.png";